import { cn } from "../../lib/utils";

const WRAPPER_CLASS = "flex min-h-0 flex-1 items-center justify-center p-3";

interface CenteredMessageProperties {
  message: string;
  className?: string;
}

// Muted, centered message for a container's empty state (no data to show).
export function EmptyState({ message, className }: CenteredMessageProperties) {
  return (
    <div className={cn(WRAPPER_CLASS, className)}>
      <p className="text-muted-foreground text-xs">{message}</p>
    </div>
  );
}

// Centered, destructive-colored message for a container's load-error state.
export function ErrorState({ message, className }: CenteredMessageProperties) {
  return (
    <div role="alert" className={cn(WRAPPER_CLASS, className)}>
      <p className="text-destructive text-xs">{message}</p>
    </div>
  );
}
